import React from "react";

export default function Profile() {
  return (
    <div>
      <h1>iam profile </h1>
    </div>
  );
}
